/**
 * viron-bnpl.js
 * 
 * Handles modal open/close for the VIRON BNPL (Tabby / Tamara) modals.
 * Also recalculates installment prices when variant price changes.
 *
 * HOW TO INSTALL:
 *  1. Upload this file to your Shopify theme: Assets → Add asset → viron-bnpl.js
 *  2. In theme.liquid <head>, add before </head>:
 *       {{ 'viron-bnpl.js' | asset_url | script_tag }}
 *  3. Done. No dependencies.
 */

(function () {
  'use strict';

  // ── Constants ─────────────────────────────────────────────────────────────
  const MODAL_OPEN_CLASS  = 'is-open';
  const ATTR_OPEN         = 'data-viron-bnpl-open';
  const ATTR_CLOSE        = 'data-viron-bnpl-close';
  const ATTR_UNIT         = 'data-viron-bnpl-unit';
  const ATTR_BASE_PRICE   = 'data-base-price';
  const ATTR_INSTALLMENTS = 'data-installments';
  const MODAL_ID_PREFIX   = 'viron-bnpl-modal--';

  // ── Open modal ─────────────────────────────────────────────────────────────
  function openModal(provider) {
    const modal = document.getElementById(MODAL_ID_PREFIX + provider);
    if (!modal) return;

    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add(MODAL_OPEN_CLASS);
    document.body.style.overflow = 'hidden';

    // Focus trap: move focus into panel
    const closeBtn = modal.querySelector('.viron-bnpl-modal__close');
    if (closeBtn) {
      setTimeout(() => closeBtn.focus(), 50);
    }
  }

  // ── Close modal ────────────────────────────────────────────────────────────
  function closeModal(provider) {
    const modal = document.getElementById(MODAL_ID_PREFIX + provider);
    if (!modal) return;

    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove(MODAL_OPEN_CLASS);
    document.body.style.overflow = '';
  }

  function closeAllModals() {
    document.querySelectorAll('.viron-bnpl-modal').forEach(modal => {
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove(MODAL_OPEN_CLASS);
    });
    document.body.style.overflow = '';
  }

  // ── Format money (AED) ─────────────────────────────────────────────────────
  // Shopify prices are in cents. Convert to AED and format.
  function formatMoney(cents) {
    const aed = cents / 100;
    return 'AED ' + aed.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // ── Update installment prices ──────────────────────────────────────────────
  function updateInstallmentPrices(newPriceCents) {
    document.querySelectorAll('[' + ATTR_UNIT + ']').forEach(el => {
      const installments = parseInt(el.getAttribute(ATTR_INSTALLMENTS) || '4', 10);
      const unitPrice    = Math.ceil(newPriceCents / installments);
      el.textContent     = formatMoney(unitPrice);
    });
  }

  // ── Event delegation: open ─────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    // Open trigger
    const openTarget = e.target.closest('[' + ATTR_OPEN + ']');
    if (openTarget) {
      e.preventDefault();
      const provider = openTarget.getAttribute(ATTR_OPEN);
      openModal(provider);
      return;
    }

    // Close trigger (button or backdrop)
    const closeTarget = e.target.closest('[' + ATTR_CLOSE + ']');
    if (closeTarget) {
      e.preventDefault();
      const provider = closeTarget.getAttribute(ATTR_CLOSE);
      closeModal(provider);
      return;
    }
  });

  // ── Keyboard: Escape closes modals ────────────────────────────────────────
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllModals();
    }
  });

  // ── Shopify variant change listener ───────────────────────────────────────
  // Listens for the native Shopify variant:changed event emitted by product forms.
  document.addEventListener('variant:changed', function (e) {
    if (e.detail && e.detail.variant && e.detail.variant.price) {
      updateInstallmentPrices(e.detail.variant.price);
    }
  });

  // Also listen for the newer Shopify theme events (Shopify 2.0 themes)
  document.addEventListener('product-form:variant-change', function (e) {
    if (e.detail && e.detail.variant && e.detail.variant.price) {
      updateInstallmentPrices(e.detail.variant.price);
    }
  });

  // ── Init: read base price from DOM and set initial state ──────────────────
  document.addEventListener('DOMContentLoaded', function () {
    // Read the first price element as base (already rendered by Liquid)
    // This ensures the price is correct on first load without JS recalculation.
    // Variant changes will trigger recalculation via the events above.

    // Prevent background scroll when a modal is already open on load (edge case)
    const openModal = document.querySelector('.viron-bnpl-modal.' + MODAL_OPEN_CLASS);
    if (openModal) {
      document.body.style.overflow = 'hidden';
    }
  });

})();
